/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateLocationProductsRequestInner
 */
export interface UpdateLocationProductsRequestInner {
    /**
     * 
     * @type {string}
     * @memberof UpdateLocationProductsRequestInner
     */
    id: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateLocationProductsRequestInner
     */
    enabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateLocationProductsRequestInner
     */
    copies?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateLocationProductsRequestInner
     */
    printers?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof UpdateLocationProductsRequestInner
     */
    stock?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateLocationProductsRequestInner
     */
    refillPolicy?: UpdateLocationProductsRequestInnerRefillPolicyEnum | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateLocationProductsRequestInner
     */
    lowStockThreshold?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateLocationProductsRequestInner
     */
    hideOnLowStock?: boolean | null;
}


/**
 * @export
 */
export const UpdateLocationProductsRequestInnerRefillPolicyEnum = {
    UntilSoldOut: 'until-sold-out',
    RefillShift: 'refill-shift',
    RefillDaily: 'refill-daily',
    JustToday: 'just-today'
} as const;
export type UpdateLocationProductsRequestInnerRefillPolicyEnum = typeof UpdateLocationProductsRequestInnerRefillPolicyEnum[keyof typeof UpdateLocationProductsRequestInnerRefillPolicyEnum];


/**
 * Check if a given object implements the UpdateLocationProductsRequestInner interface.
 */
export function instanceOfUpdateLocationProductsRequestInner(value: object): value is UpdateLocationProductsRequestInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function UpdateLocationProductsRequestInnerFromJSON(json: any): UpdateLocationProductsRequestInner {
    return UpdateLocationProductsRequestInnerFromJSONTyped(json, false);
}

export function UpdateLocationProductsRequestInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLocationProductsRequestInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
        'copies': json['copies'] == null ? undefined : json['copies'],
        'printers': json['printers'] == null ? undefined : json['printers'],
        'stock': json['stock'] == null ? undefined : json['stock'],
        'refillPolicy': json['refillPolicy'] == null ? undefined : json['refillPolicy'],
        'lowStockThreshold': json['lowStockThreshold'] == null ? undefined : json['lowStockThreshold'],
        'hideOnLowStock': json['hideOnLowStock'] == null ? undefined : json['hideOnLowStock'],
    };
}

export function UpdateLocationProductsRequestInnerToJSON(json: any): UpdateLocationProductsRequestInner {
    return UpdateLocationProductsRequestInnerToJSONTyped(json, false);
}

export function UpdateLocationProductsRequestInnerToJSONTyped(value?: UpdateLocationProductsRequestInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'enabled': value['enabled'],
        'copies': value['copies'],
        'printers': value['printers'],
        'stock': value['stock'],
        'refillPolicy': value['refillPolicy'],
        'lowStockThreshold': value['lowStockThreshold'],
        'hideOnLowStock': value['hideOnLowStock'],
    };
}

